// Mock data pour le site de Siriane Belliard-Reynes - Neuro Thérapie

export const methodSystems = [
  {
    id: 1,
    name: "Système Neuro-végétatif",
    image: "https://images.unsplash.com/photo-1554424518-336ec861b705?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHw0fHx3ZWxsbmVzcyUyMHJlbGF4YXRpb258ZW58MHx8fHwxNzU5NjAwNzA3fDA&ixlib=rb-4.1.0&q=85",
    description: "La dystonie neuro-végétative est souvent la cause de nombreux symptômes, notamment la fatigue et l'irritabilité. Cela affecte le fonctionnement normal des systèmes sympathique et para-sympathique. Le réguler est donc d'une importance capitale."
  },
  {
    id: 2,
    name: "Système Endocrinien",
    image: "https://images.unsplash.com/photo-1506126613408-eca07ce68773?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxtZWRpdGF0aW9ufGVufDB8fHx8MTc1OTYwMDY5NXww&ixlib=rb-4.1.0&q=85",
    description: "Au cœur de cette technique se trouve la capacité régulatrice de nos huit glandes endocrines, aussi appelés huit merveilleux vaisseaux en médecine traditionnelle chinoise."
  },
  {
    id: 3,
    name: "Structure",
    image: "https://images.unsplash.com/photo-1611073615848-d6ff6215931f",
    description: "Certaines restrictions de mobilité sont primaires, surtout après un traumatisme. Il est primordial de les traiter pour restaurer la fonction et prévenir des déséquilibres hormonaux récurrents."
  },
  {
    id: 4,
    name: "L'Émotionnel",
    image: "https://images.unsplash.com/photo-1688382575775-9aaa5025524e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxwZWFjZWZ1bCUyMHNsZWVwfGVufDB8fHx8MTc1OTYwMDcwMXww&ixlib=rb-4.1.0&q=85",
    description: "Bien qu'il existe de nombreux perturbateurs endocriniens, l'émotionnel reste une cause majeure des dérèglements hormonaux et, par conséquent, des maladies. Il est donc indispensable de traiter les émotions."
  }
];

export const sessionStats = [
  {
    label: "Durée moyenne d'une séance",
    value: "60 min"
  },
  {
    label: "Suivi après séance si besoin",
    value: "100 %"
  },
  {
    label: "Prise en charge individualisée",
    value: "100%"
  }
];

export const osteopathyPrinciples = [
  "Évaluation holistique des différents systèmes du corps",
  "Techniques manuelles douces adaptées à chaque patient",
  "Intégration des dimensions physique et émotionnelle",
  "Approche préventive pour maintenir l'équilibre à long terme"
];

export const aboutSections = [
  {
    title: "Ma Pratique",
    text: "Bienvenue dans mon cabinet de neuro thérapie, une approche globale qui considère l'influence des systèmes nerveux et hormonal sur l'ensemble du corps pour rétablir l'harmonie naturelle."
  },
  {
    title: "Mon Approche",
    text: "Mon approche thérapeutique se concentre sur la restauration de l'équilibre corporel dans sa globalité. En identifiant les déséquilibres profonds, je travaille à réactiver les mécanismes naturels d'auto-régulation du corps."
  },
  {
    title: "Ma Méthodologie",
    text: "La neuro thérapie permet de rétablir l'équilibre des relations entre les différents systèmes du corps, favorisant ainsi sa capacité innée à maintenir un état d'équilibre et d'harmonie."
  },
  {
    title: "Formation Continue",
    text: "Je suis en formation continue pour toujours améliorer les prises en charge et approfondir les diverses connaissances sur le corps, la psychologie, l'influence du vécu sur notre santé et nos dérèglements."
  }
];

export const aboutBadges = [
  "Approche personnalisée",
  "Techniques modernes",
  "Équilibre corporel"
];

export const heroContent = {
  badge: "Neuro-thérapie & bien-être",
  title: "Retrouver l'équilibre intérieur pour un corps plus serein.",
  description: "Grâce à des techniques neuro-thérapeutiques douces, je vous aide à libérer les tensions, calmer le système nerveux et redonner de la fluidité à vos mouvements quotidiens.",
  ctaButton1: "Prendre rendez-vous",
  ctaButton2: "Découvrir ma méthode",
  features: [
    {
      title: "Approche globale",
      description: "Rééquilibrage du système nerveux et du corps dans son ensemble."
    },
    {
      title: "Accompagnement personnalisé",
      description: "Des séances adaptées à vos besoins et à votre rythme."
    },
    {
      title: "Méthodes douces",
      description: "Techniques respectueuses pour libérer les tensions durablement."
    }
  ],
  image: "https://images.unsplash.com/photo-1611073615848-d6ff6215931f",
  quote: "Chaque séance est un pas supplémentaire vers un équilibre durable entre votre corps et votre esprit."
};

export const contactInfo = {
  address: {
    street: "9 rue du Docteur Mourier",
    city: "77430 Champagne-sur-Seine",
    mapsUrl: "https://maps.google.com/?q=9+rue+du+Docteur+Mourier+77430+Champagne-sur-Seine"
  },
  phone: {
    display: "06 36 14 31 26",
    link: "+33636143126",
    hours: "Du lundi au vendredi"
  },
  email: {
    address: "neuro.endo.therapeute@gmail.com",
    responseTime: "Réponse sous 48h"
  },
  schedule: {
    weekdays: "Du lundi au vendredi",
    weekend: "Weekend: Fermé"
  }
};

export const reasonsToConsult = [
  "Douleurs",
  "Troubles du sommeil",
  "Stress et anxiété",
  "Problèmes digestifs",
  "Maux de tête et migraines",
  "Déséquilibres hormonaux",
  "Libération des contraintes et blocages empêchant la communication organe ↔ cerveau"
];

export const consultationInfo = {
  duration: "Environ 60 minutes",
  price: "70€",
  preparation: "Pour des raisons techniques, un accès dégagé au dos et à la colonne vertébrale est indispensable. Merci de venir en sous-vêtements permettant une bonne visibilité du dos, ou en short. Les tenues trop enveloppantes (body, caraco, brassière, etc.) peuvent gêner la séance.",
  note: "Consultation sur rendez-vous uniquement"
};
